import { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { login } from '../api';

export default function Login() {
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();
  const [params] = useSearchParams();

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await login(password);
      navigate(params.get('next') || '/dashboard', { replace: true });
    } catch (err) {
      setError(err instanceof Error ? err.message : 'login failed');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="login">
      <Link className="login-home" to="/">
        Tentacle
      </Link>
      <form className="login-form" onSubmit={submit}>
        <div className="login-heading">
          <p>Private workspace</p>
          <h1>Dashboard access</h1>
          <span>Enter the shared password to continue.</span>
        </div>
        <div className="field login-password-field">
          <label className="label" htmlFor="password">
            Password
          </label>
          <input
            id="password"
            type="password"
            value={password}
            autoFocus
            autoComplete="current-password"
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
        <button className="primary" type="submit" disabled={busy || !password}>
          {busy ? 'Opening…' : 'Open dashboard'}
        </button>
        {error ? (
          <p className="fail" style={{ fontSize: 13, marginTop: 14 }}>
            {error}
          </p>
        ) : null}
      </form>
      <Link className="login-back" to="/">
        Back to the studio
      </Link>
    </div>
  );
}
